import { Component, OnInit, Input, ViewChild, Directive, Renderer, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { TimeOfDayService } from './../../common/services/time-of-day.service';
import { ProgrammingUtilsService } from './../../common/services/utils.service';
import { SharedProgrammingService } from './../../common/services/shared-programming.service';
import { BaseRoutingComponent } from '../../common/base-routing/base-routing.component';
import { CommonProgrammingContext } from '../../common/services/shared-programming.service';
import { ProgrammingUtilsService as Utils } from '../../common/services/utils.service';
import { EventsUIService, EventsUIContext, EVENTS_BY, EVENTS_FILTER, EVENTS_UI_ACTIONS } from './eventsUI.service';

interface MenuItem {
  label: string,
  token: EVENTS_BY | EVENTS_FILTER
}

@Component({
  selector: 'prg-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.less']
})
export class EventsComponent extends BaseRoutingComponent implements OnInit {
  currentGrouping: Observable<any>;
  searchText: Observable<string>;
  expanded: Observable<boolean>;
  ready: Observable<boolean>;
  currentTime: Observable<string>;

  todayView: boolean;
  filterMenuOpen: boolean;

  _searchText: string;

  _by: Observable<MenuItem>;
  _filter: Observable<MenuItem>;

  private _bys: MenuItem[] = [
    {
      label: 'Description',
      token: EVENTS_BY.ALL
    },
    {
      label: 'Today',
      token: EVENTS_BY.TODAY
    },
    {
      label: 'Scheduled',
      token: EVENTS_BY.SCHEDULED
    },
    {
      label: 'Room',
      token: EVENTS_BY.ROOM
    },
    {
      label: 'Device',
      token: EVENTS_BY.DEVICE
    }
  ];

  private _filters: MenuItem[] = [
    {
      label: 'All Automations',
      token: EVENTS_FILTER.ALL
    },
    {
      label: 'My Automations',
      token: EVENTS_FILTER.MY
    }
  ];

  @Input() source: Event[];

  @ViewChild('filterMenu') filterMenu;

  private EVENTS_BY = EVENTS_BY;
  private EVENTS_FILTER = EVENTS_FILTER;

  constructor(
    protected router: Router,
    private route: ActivatedRoute,
    protected store: Store<{
      sharedProgramming: CommonProgrammingContext,
      eventsUI: EventsUIContext
    }>,
    protected shared: SharedProgrammingService,
    private utils: ProgrammingUtilsService,
    private timeOfDay: TimeOfDayService,
    private uiService: EventsUIService
  ) {
    super();

    this.todayView = false;
    this.filterMenuOpen = false;

    this.currentGrouping = this.shared.currentGrouping;
    this.searchText = this.shared.searchText;
    this.expanded = this.shared.listExpanded;
    this.ready = this.shared.isReady;

    this._by = this.store.select(s => s.eventsUI.by)
      .map(by => this._bys.find(mi => mi.token == by));

    this._filter = this.store.select(s => s.eventsUI.filter)
      .map(filter => this._filters.find(f => f.token == filter));
  }

  ngOnInit() {
    this.shared.clearError();
    this.shared.clearSelectedEvent();
    // NOTE ensure the events view always starts collapsed
    this.shared.setEditing(false);
    this.shared.setListExpanded(false);

    this.todayView = (window.location.href.indexOf('today') >= 0);

    this.currentTime = this.timeOfDay.timeOfDay.map(t => this.utils.toTimeDisplay(
      t.getFullYear(),
      t.getMonth() + 1,
      t.getDate(),
      (t.getHours() * 60 + t.getMinutes())
    ));

    this._searchText = Utils.snapshot<string>(this.shared.searchText);
  }

  private searchTextChanged(event: any) {
    this.shared.setSearchText(event.target.value);
  }

  isActive(path: string): boolean {
    return (window.location.href.indexOf(path) > 0);
  }

  private goAdd() {
    this.router.navigate(['quickstarts/triggers'], { relativeTo: this.moduleRoot });
  }

  private updateSearchText(event: any) {
    this.shared.setSearchText(event.target.value);
  }

  toggleExpand() {
    this.shared.toggleListExpanded();
  }

  private _updateBy = (by: string) => {
    this.store.dispatch({
      type: EVENTS_UI_ACTIONS.SET_BY,
      payload: by
    });
  }

  private _updateFilter = (filter: string) => {
    this.store.dispatch({
      type: EVENTS_UI_ACTIONS.SET_FILTER,
      payload: filter
    });
  }
}


@Directive({
  selector: '[cxGrabFocus]'
})
export class FocusGrabbingInputAttribute {
  constructor(private renderer: Renderer, public elementRef: ElementRef) { }

  ngOnInit() {
    this.renderer.invokeElementMethod(this.elementRef.nativeElement, 'focus', []);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/events/events.component.ts